import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import { Button } from '@/shared/components/ui/button';
import { LordIcon } from '@/shared/components/ui/lord-icon';

interface StoreSchedulingModalProps {
  isOpen: boolean;
  onClose: () => void;
  storeName?: string;
  nextOpeningTime?: string;
}

/**
 * Modal informativo exibido uma única vez por sessão quando a loja está
 * fechada mas aceita pedidos agendados. Explica ao usuário que ele pode
 * montar o pedido normalmente e agendá-lo para mais tarde.
 */
export function StoreSchedulingModal({
  isOpen,
  onClose,
  storeName,
  nextOpeningTime,
}: StoreSchedulingModalProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="max-w-[90vw] sm:max-w-md mx-auto">
        <DialogHeader className="items-center text-center space-y-3">
          <LordIcon
            src="/lordicons/clock.json"
            trigger="in"
            className="w-14 h-14"
          />
          <DialogTitle className="text-lg font-bold">
            Loja fechada no momento
          </DialogTitle>
          <DialogDescription className="text-sm text-gray-600">
            {storeName ? (
              <>
                A <span className="font-medium text-gray-900">{storeName}</span> está
                fechada agora, mas você pode montar seu pedido e agendá-lo para mais
                tarde.
              </>
            ) : (
              'A loja está fechada agora, mas você pode montar seu pedido e agendá-lo para mais tarde.'
            )}
          </DialogDescription>
        </DialogHeader>

        {nextOpeningTime && (
          <p className="text-center text-xs text-gray-500">Abre {nextOpeningTime}</p>
        )}

        <DialogFooter>
          <Button className="w-full" onClick={onClose}>
            Entendi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
